import Vue from 'vue';
import Vuex from 'vuex';

import { Auth } from 'aws-amplify';
import axios from 'axios';

import msapi from '../api/mindsync'
// import router from '../router'
import ui from './modules/ui'

Vue.use(Vuex)


// const API_URI = '192.168.1.10:8088'
const API_URI = 'https://do8x9ojywa.execute-api.ca-central-1.amazonaws.com/dev'


function pimpam () {
  // Add latest auth access token to every http request
  axios.interceptors.request.use(function (config) {
    return Auth.currentSession()
      .then(session => {
        // console.log(session)
        // User is logged in. Set auth header on all requests
        config.headers.Authorization = 'Bearer ' + session.idToken.jwtToken
        return Promise.resolve(config)
      })
      .catch(() => {
        // No logged-in user: don't set auth header
        console.log('!! No logged-in user')
        return Promise.resolve(config)
      })
  })
}


export const store = new Vuex.Store({
  modules: {ui},
  state: {
    // version: '0.1',
    recent: [],
    loveit: [],
    feed: [],
    seen: [],
    docByID: null,
    included: [],
    trash: [],
    pending: [],
    // opinprogress: false,

    mrr: null, // response from AI API

    fxUser: JSON.parse(localStorage.getItem('fxUser')) || false,
    isUserSignedIn: false,
  },

  getters: {
    isLoggedIn: state => {
      console.log(`>> getters.isLoggedIn = ${state.fxUser}`)
      return state.fxUser
    },
    // isLoggedIn: () => {
    //   const bb = (async () => {
    //     try {
    //       const cau = await Auth.currentAuthenticatedUser();
    //       console.log(cau);
    //       if (cau !== undefined) {
    //         return true;
    //       }
    //     } catch (error) {
    //       console.error(error)
    //     }
    //     return false;
    //   })();
    //   console.log(bb);
    //   return false;
    // },

    isNotSeen: state => {
      console.log('- isNotSeen: getters');
      var ret = state.included.filter(el => {
        return (!el.attributes.seenit && !el.attributes.trashit && !el.attributes.loveit);
      });
      return ret;
    },
    isSeen: state => {
      console.log('- isSeen: getters');
      var ret = state.included.filter(el => {
        return el.attributes.seenit;
      });
      return ret;
    },
    isLoved: state => {
      console.log('- isSeen: getters');
      var ret = state.included.filter(el => {
        return (!el.attributes.seenit && el.attributes.loveit);
      });
      return ret;
    },

    included: state => url_hash => {
      var idx = state.docByID[url_hash]
      var obj = state.included[idx]
      return obj.attributes
    }
  },

  mutations: {

    resetState: (state) => {
      state.recent = []
      state.loveit = []
      state.feed = []
      state.seen = []
      state.docByID = {}
      state.included = []
      state.trash = []
      state.pending = []

      state.isUserSignedIn = false
      state.fxUser = false

      state.mrr = null // response from NLP API
    },

    setLoggedIn: (state, newValue) => {
      console.log(`setLoggedIn to ${newValue}`)
      state.isUserSignedIn = newValue
      state.fxUser = newValue
    },

    attachTA: (state, payload) => {
      state.mrr = payload.data;
      console.log(payload.data);
      for (var dobj of state.included) {
        if (dobj.id === payload.oid) {
          dobj.ta = payload.data;
          break;
        }
      }
    },

    setRecent: (state, recent) => {
      state.recent = recent;
    },
    extendRecent: (state, new_recent) => {
      state.recent = state.recent.concat(new_recent);
    },
    extendIncluded: (state, new_included) => {
      state.included = state.included.concat(new_included);
    },
    extendPending: (state, new_pending) => {
      console.log('> extendPending mutation');
      // state.opinprogress = true;
      state.pending = state.pending.concat(new_pending);
    },

    setLoveIt: (state, loveit) => {
      state.loveit = loveit;
    },
    setFeed: (state, feed) => {
      state.feed = feed;
    },
    setTrash: (state, trash) => {
      state.trash = trash;
    },
    
    // setSeen: (state, seen) => {
    //   state.seen = seen;
    // },
    setIncluded: (state, included) => {
      console.log('=> commit setIncluded')
      if (!Array.isArray(included)) {
        return;
      }
      state.included = included;
      state.included.sort((a, b) => {return a.attributes.created_time < b.attributes.created_time ? 1 : -1})

      state.docByID = {}
      for (var v in state.included) {
        var doc = state.included[v]
        state.docByID[doc.id] = v
      }
    },

    flipLoveIt: (state, url_hash) => {
      console.log('flipLoveIt mutations. url_hash = ' + url_hash);
      var idx = state.docByID[url_hash];
      if (idx !== -1) {
        state.included[idx]['attributes']['loveit'] = !state.included[idx]['attributes']['loveit'];
      }
    },
    flipSeenIt: (state, url_hash) => {
      console.log('flipSeenIt mutations. url_hash = ' + url_hash);
      var idx = state.docByID[url_hash];
      if (idx !== -1) {
        state.included[idx]['attributes']['seenit'] = !state.included[idx]['attributes']['seenit'];
      }
    },
    flipTrashIt: (state, url_hash) => {
      console.log('flipTrashIt mutations. url_hash = ' + url_hash);
      var idx = state.docByID[url_hash];
      if (idx !== -1) {
        state.included[idx]['attributes']['trashit'] = !state.included[idx]['attributes']['trashit'];
      }
    },

    postNewBit: (state, bio) => {
      console.log('postNewBit mutations:\nbio::\n');
      console.log(bio);
      console.log('logic for handling new item in the UI\n\n* should we add new tile here?\n');
    },
  },


  actions: {

    doRefresh() {
      pimpam()
    },

    tryLogin({commit}, userdata){
      console.log('> tryLogin');
      return new Promise((resolve, reject) => {
        // console.log(Auth);
        Auth.signIn(userdata.username, userdata.password)
        .then(user => {
          // console.log(user);

          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            console.log('NEW_PASSWORD_REQUIRED');
            Auth.completeNewPassword(
              user,
              '<NEW_PASSWORD_REQUIRED>'
            ).then(user2 => {
              console.log(user2);
              console.log(commit);
            }).catch(e => {
              console.log(e);
              reject(e)
            });
          } else {
            localStorage.setItem('fxUser', JSON.stringify(true))
            resolve(user);
          }
        })
        .catch(err => {
          reject(err);
        })

      })
    },

    logout: async ({commit, dispatch}) => {
      // localStorage.removeItem('msDataCache');
      dispatch('ui/resetActiveDoc')
      commit('resetState')
      try {
        await Auth.signOut();
        localStorage.clear();
      } catch (error) {
        console.log('error signing out: ', error);
      }
    },

    pullTA: ({commit}, url_hash) => {
      // console.log(context);
      return new Promise((resolve, reject) => {
        axios.get(API_URI + '/api/v0/sentiment/'.concat(url_hash)).then(response => {
          commit('attachTA', {oid: url_hash, data: response.data.data});
          console.log('pullTA action complete');
        })
        console.log('pullTA action complete. url_hash = ' + url_hash);
        console.log(resolve)
        console.log(reject)
      })
    },


    extendRecent: context => {
      axios.get(API_URI + '/api/v0/recent').then(response => {
        context.commit('extendRecent', response.data.data.relationships.bot.data)
        context.commit('extendIncluded', response.data.included);
        console.log('extendRecent action complete');
      })
    },

    flipLoveIt: ({commit, state}, url_hash) => {
      commit('flipLoveIt', url_hash);
      let idx = state.docByID[url_hash];
      if (idx !== -1) {
        let update_body = {'loveit': state.included[idx]['attributes']['loveit']};
        return msapi.putDoc(url_hash, update_body);
      }
    },

    flipSeenIt: ({commit, state}, url_hash) => {
      commit('flipSeenIt', url_hash);
      let idx = state.docByID[url_hash];
      if (idx !== -1) {
        let update_body = {'seenit': state.included[idx]['attributes']['seenit']};
        return msapi.putDoc(url_hash, update_body);
      }
    },

    flipTrashIt: ({commit, state}, url_hash) => {
      commit('flipTrashIt', url_hash);
      let idx = state.docByID[url_hash];
      if (idx !== -1) {
        let update_body = {'trashit': state.included[idx]['attributes']['trashit']};
        return msapi.putDoc(url_hash, update_body);
      }
    },


    postNewBit: ({commit, dispatch}, bio) => {
      console.log('postNewBit action');

      // preprocess bio
      // remove trailing slash if there is one
      // split string by dashes
      // replace dashes with spaces
      // append infered title to text
      var split_bio = bio.trim().replace(/[-/]+$/g, "").split('/');
      var last_part = split_bio.pop();
      var title_hint = last_part.replaceAll('-', ' ');

      var msg = bio + " " + title_hint

      const entry_obj = {
        'trashit': false,
        'loveit': false,
        'source': 'webui',
        'text': msg,
      }
      console.log(entry_obj);
      commit('extendPending', entry_obj);

      const config = {
          method: 'post',
          url: API_URI + '/api/v0/docs',
          data: entry_obj,
          // headers: {
          //   'User-Agent': 'WebUI',
          //   'Access-Control-Allow-Origin': '*'
          // }
      }
      axios(config).then(response => {
          console.log('> postNewBit mutation: POST complete');
          console.log(response);
          commit('postNewBit', bio);
          dispatch('ui/raiseInfo', response.status === 200 ? 'success' : response.status);
          // dispatch('ui/closePostDialog');
      }).catch(e => {
        console.log('!! postNewBit action exception');
        dispatch('ui/raiseError', e);
      });

      return;
    },

    updateState: ({commit}, data) => {
      commit('setIncluded', data.included);

      commit('setRecent', data.data.relationships.recent.data);
      commit('setLoveIt', data.data.relationships.love.data);
      commit('setFeed', data.data.relationships.feeds.data);
      commit('setTrash', data.data.relationships.trash.data);
    },

    forceSync: context => {
      console.log('> forceSync action:');
      context.dispatch('ui/raiseInfo', 'Syncing..');
      axios.get(API_URI + '/api/v0/test').then(response => {
        // console.log(response.data.data.relationships.love.data);
        if (!Array.isArray(response.data.included)) {
          context.dispatch('ui/raiseInfo', 'No articles found. The button on the lower-right .');
          console.log('EMPTY INCLUDED Array');
          return;
        }
        localStorage.setItem('msDataCache', JSON.stringify(response.data));
        const nItems = response.data.included.length;
        context.dispatch('ui/raiseInfo', `Received ${nItems} items.`);
        context.dispatch('updateState', response.data);
      }).catch(e => {
        console.log('!! forceSync action exception');
        console.log(e);
        context.dispatch('ui/raiseError', 'Sync failed: ' + e);
        // context.dispatch('logout');
      });
    },

    sync: async ({commit, dispatch}) => {
      // mild sync that can also use local cache after refresh

      console.log('=> sync action..');

      const cau = await Auth.currentAuthenticatedUser()
      // console.log(cau)
      if (cau !== undefined) {
        commit('setLoggedIn', true)
        let myLocalData = JSON.parse(localStorage.getItem('msDataCache'))
        if (myLocalData) {
          console.log('--> using local cache..');
          dispatch('updateState', myLocalData)
        } else {
          dispatch('forceSync')
        }
      }
      // context.dispatch('forceSync');

      console.log('=> sync action complete.');
    }

  }
})


// Auth.currentSession()
//   .then(data => {
//     console.log(data)
//     let id_token = data.getIdToken().getJwtToken()
//     console.log(id_token)
//     // axios.defaults.headers.common['Authorization'] = id_token;
//   })
//   .catch(err => console.log(err));
//
// // Async call to Cognito to check for token
// // This will be checked every time a protected route is loaded
// Auth.currentSession()
//   .then((response) => {
//
//       Axios.defaults.headers.common = {
//           authToken: response.idToken.jwtToken,
//       };
//
//   })
//   .catch((error) => {
//       console.log(error);
//   });
//
//
// function bimbambam () {
//   let session = cognitoUser.getSession()
//   refresh_token = session.getRefreshToken();   // you'll get session from calling cognitoUser.getSession()
//   if (AWS.config.credentials.needsRefresh()) {
//     cognitoUser.refreshSession(refresh_token, (err, session) => {
//       if(err) {
//         console.log(err);
//       } 
//       else {
//         AWS.config.credentials.params.Logins['cognito-idp.<YOUR-REGION>.amazonaws.com/<YOUR_USER_POOL_ID>']  = session.getIdToken().getJwtToken();
//         AWS.config.credentials.refresh((err)=> {
//           if(err)  {
//             console.log(err);
//           }
//           else{
//             console.log("TOKEN SUCCESSFULLY UPDATED");
//           }
//         });
//       }
//     });
//   }
// }
//
// logout({commit}){
//   return new Promise((resolve,) => {
//     console.log('> logout action');
//     commit('logout');
//     Auth.signOut();
//
//     localStorage.removeItem('msDataCache');
//     delete axios.defaults.headers.common['Authorization'];
//     // console.log(reject);
//
//     // this.$router.replace('/signin');
//     // this.$router.push({ name: 'signin' });
//
//     resolve();
//   })
// },
